import { ProductLocationForm } from '@partials/forms/product-detail/product-location'

export type IProductLocationTab = Parameters<typeof ProductLocationForm>[0]

export const ProductLocationTab = ({ onError }: IProductLocationTab) => {
  return <ProductLocationForm onError={onError} />
}
